import { create } from 'zustand';

import { ContractFilters } from '@/data/models/contract.interface';
import { Platform } from '@/data/models/platform.interface';
import { Tenant } from '@/data/models/tenant.interface';

interface ContractsSelectionState {
  prefilledPlatform: Platform | null;
  prefilledTenant: Tenant | null;
  prefilledFilters: ContractFilters | null;
  prefilledContractPlatform: string | null;
  currentPlatform: Platform | null;
  currentTenant: Tenant | null;
  currentFilters: ContractFilters | null;
  currentContractPlatform: string | null;
  setPrefilledSelection: (
    _platform: Platform | null,
    _tenant: Tenant | null,
    _filters: ContractFilters | null,
  ) => void;
  setPrefilledContractPlatform: (_platform: string | null) => void;
  clearPrefilledSelection: () => void;
  setCurrentSelection: (
    _platform: Platform | null,
    _tenant: Tenant | null,
    _filters: ContractFilters | null,
  ) => void;
  clearCurrentSelection: () => void;
}

const useContractsSelectionStore = create<ContractsSelectionState>((set) => ({
  prefilledPlatform: null,
  prefilledTenant: null,
  prefilledFilters: null,
  prefilledContractPlatform: null,
  currentPlatform: null,
  currentTenant: null,
  currentFilters: null,
  currentContractPlatform: null,

  setPrefilledSelection: (
    platform: Platform | null,
    tenant: Tenant | null,
    filters: ContractFilters | null,
  ) => {
    set({
      prefilledPlatform: platform,
      prefilledTenant: tenant,
      prefilledFilters: filters,
    });
  },

  setPrefilledContractPlatform: (platform: string | null) => {
    set({ prefilledContractPlatform: platform });
  },

  clearPrefilledSelection: () => {
    set({
      prefilledPlatform: null,
      prefilledTenant: null,
      prefilledFilters: null,
      prefilledContractPlatform: null,
    });
  },

  setCurrentSelection: (
    platform: Platform | null,
    tenant: Tenant | null,
    filters: ContractFilters | null,
  ) => {
    set({
      currentPlatform: platform,
      currentTenant: tenant,
      currentFilters: filters,
    });
  },

  clearCurrentSelection: () => {
    set({
      currentPlatform: null,
      currentTenant: null,
      currentFilters: null,
      currentContractPlatform: null,
    });
  },
}));

export default useContractsSelectionStore;
